const hasUnsavedIntent = ({ store, path }) => {
  const isFromIntents = path === '/iqtools/intents' || path === '/iqtools';
  const isIntentSelected = store.getters['intents/selected'];
  const isDirtyForm = !store.getters['intents/formIntent/pristine'];

  return isFromIntents && isIntentSelected && isDirtyForm;
};

const hasUnsavedDialog = ({ store, path }) => {
  const isFromDialogs = path === '/iqtools/dialogs';
  const isDialogSelected = store.getters['dialogs/selected'];
  const isDirtyForm = !store.state.dialogs.selectedIsPristine;

  return isDialogSelected && isFromDialogs && isDirtyForm;
};

export const confirmUnsavedWarning = {
  title: 'Your changes won\'t be saved',
  content: 'We won\'t be able to save your data if you move away from this page.',
};

const DEFAULT_CONFIRM_OPTIONS = {
  confirmButtonText: 'Discard',
  cancelButtonText: 'Go back',
};

/** Tracks in-flight confirm dialogs per vm to prevent multiple dialogs for the same page */
const pendingConfirmByVm = new WeakMap();

/**
 * Prompts user to confirm discarding unsaved changes when in edit mode.
 * Use before navigating away, switching items, or going to list view.
 * Blocks multiple dialogs: concurrent calls for the same vm share one dialog and result.
 *
 * @param {Object} vm - Vue component instance (needs $aiq.confirm)
 * @param {Object} [confirmOptions] - Optional overrides for the confirm dialog (merged with defaults)
 * @returns {Promise<boolean>} - true if can proceed (no changes or user confirmed), false if user cancelled
 */
export const confirmDiscardUnsavedChanges = async(vm, confirmOptions = {}) => {

  const pending = pendingConfirmByVm.get(vm);
  if (pending) return pending;

  const promise = (async() => {
    try {
      const { title, content } = confirmUnsavedWarning;
      await vm.$aiq.confirm(title, content, { ...DEFAULT_CONFIRM_OPTIONS, ...confirmOptions });
      return true;
    } catch {
      return false;
    } finally {
      pendingConfirmByVm.delete(vm);
    }
  })();

  pendingConfirmByVm.set(vm, promise);
  return promise;
};

export const ifShowPopup = ({ store, from, next }, confirm) => {
  const { path } = from;
  const info = { store, path };

  if (hasUnsavedIntent(info) || hasUnsavedDialog(info)) {
    const { title, content } = confirmUnsavedWarning;
    return confirm(title, content).then(
      selection => {
        if (selection.dismiss) {
          next(false);
        } else {
          next();
        }
      },
      () => {},
    );
  }
  next();
};

export const defaultRoute = '/error';
export const topRoutes = [
  '/conversations',
  '/iqtools',
  '/pulse',
  '/metrics',
  '/customers',
  '/users',
  '/settings',
  '/compliance',
];
